import { render, staticRenderFns } from "./PCAboutUs.vue?vue&type=template&id=00f6d004&scoped=true&"
import script from "./PCAboutUs.vue?vue&type=script&lang=js&"
export * from "./PCAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./PCAboutUs.vue?vue&type=style&index=0&id=00f6d004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f6d004",
  null
  
)

export default component.exports